import Experiments from '@alltrails/shared/types/Experiments';
import useUser from 'hooks/useUser';
import useSelector from './useSelector';

export default function useExperiment(flagKey: keyof Experiments) {
  const user = useUser();

  // experiments can be undefined on rspec
  const experiment = useSelector(state => state.experiments?.[flagKey]);

  if (typeof window !== 'undefined' && experiment) {
    global.fetch('https://api2.amplitude.com/2/httpapi', {
      body: JSON.stringify({
        api_key: __AT_DATA__.amplitudeApiKey,
        events: [
          {
            device_id: __AT_DATA__.amplitudeDeviceId,
            event_type: '$exposure',
            event_properties: { flag_key: flagKey, variant: experiment.value },
            user_id: user?.id
          }
        ]
      }),
      method: 'post'
    });
  }

  return experiment;
}
